import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import Pagination from "@mui/material/Pagination";
import NotificationApi from "../../api/NotificationApi";
import AuthService from "../../session/AuthService";
import ActivityGrid from "./ActivityGrid";
import ManageUserService from "../../api/ManageUserService";

class AcitvityContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auditList: [],
      totalCount: 0,
      totalPageno: 0,
      pageNo: 0,
      search: "",
      currentPage: 1,
      openFilterModal: false,
      filterkey: "",
      filterType: "",
      userList : []
    };
  }

  componentDidMount() {
    this.togetAuditTrailData();
    this.togetEmployeeData();
  }


  togetAuditTrailData = () => {


    let obj = {
      pageNo: 0,
      group_id: parseInt(AuthService.getUserId()),
     
    };
    NotificationApi.getAuditTrailData(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.message === "success") {
      
    
        this.setState({
          auditList: response.data.data.auditList,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });


  }

 


  togetEmployeeData = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
  
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.UserData,
        });
      }
    });
  };
    

  render() {
    return (
      <>
        <div className="Heading" >
          <NavigationChange
            Topics={"Activity"}
            numberofRecord={this.state.totalCount}
            specficwidth={"113"}
            back={true}
          />
        </div>
   
        <ActivityGrid
          OpenModal={this.OpenCreateTask}
          auditList={this.state.auditList}
          userList={this.state.userList}
        />

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageno}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>
  
      </>
    );
  }


  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        
        group_id: parseInt(AuthService.getUserId()),
      };
      NotificationApi.getAuditTrailData(obj).then((response) => {
        console.log("response" , response)
        if (response.data && response.data.message === "success") {
          this.setState({
            auditList : response.data.data.auditList,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    });
  }

 

  



 

 

 


}
export default AcitvityContainer;
